/**
 * Screens that fill the window instead of growing past it.
 *
 * Suhbatlar's panes each scroll on their own, and the page itself must not scroll, or reading
 * an old message drags the list and the composer off screen with it. The shell gives these
 * routes exactly the window's height, edge to edge, and leaves the scrolling to the panes: on a
 * phone too, where K3 keeps the filters to two scrolling rows and the composer at the bottom.
 * Every other screen keeps the ordinary page scroll.
 */
const LOCKED_PATHS: readonly string[] = ["/inbox"];

export function locksViewport(pathname: string): boolean {
  return LOCKED_PATHS.includes(pathname);
}
